import { PermissionsAPI } from '@/clients/permissions/permissions.api'
import * as types from '@/store/mutation-types'

export default {
  async getAppDetais({ commit }) {
    const { data: { payload } } = await PermissionsAPI.setAppDetails()
    commit(types.SET_APP_DETAILS, payload)
    return payload
  }
}
